import React, { Component } from 'react';
import './User.css';

class User extends Component {
  gotoTable() {
    this.props.history.push('/table');
  }

  render() {
    return (
      <div className="user">
        <div className="login">
          <h2>Login</h2>
          <Form id="login" submit="Login"
                gotoTable={this.gotoTable.bind(this)}/>
        </div>
        <div className="register">
          <h2>Register</h2>
          <Form id="register" submit="Register"
                gotoTable={this.gotoTable.bind(this)}/>
        </div>
      </div>
    );
  }
}

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      username: {value: ''},
      password: {value: ''},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({[event.target.name]: {value: event.target.value}});
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({
      username: {value: ''},
      password: {value: ''},
    });

    const url = (`${process.env.REACT_APP_SERVER_URL}`+
           `/${this.props.submit.toLowerCase()}`);

    fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: new FormData(
        document.getElementById(this.props.id))})
      .then((resp) => resp.json())
      .then((result) => {
        if (result.error) {
          this.setState({error: result.error});
        } else {
          this.props.gotoTable();
        }
      });
  }

  render() {
    return (
      <div>
        <h4 style={{color: 'red'}}>&nbsp;{this.state.error}</h4>
        <form id={this.props.id} onSubmit={this.handleSubmit}>
          Username: <input name="username" value={this.state.username.value}
                           onChange={this.handleChange} />
          <br />
          Password: <input name="password" type="password"
                           value={this.state.password.value}
                           onChange={this.handleChange} />
          <br />
          <input type="submit" value={this.props.submit} />
        </form>
      </div>
    );
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/User.js